var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkboxs"},_vm._l((_vm.refs),function(label){return _c('div',{key:label,staticClass:"checkbox"},[_c('input',{attrs:{"type":"checkbox","name":_vm.nameRef,"id":label},domProps:{"value":label,"checked":_vm.searchArray.includes(label)},on:{"change":function($event){_vm.$emit('update-search-array', {
        name: _vm.nameRef,
        checked: $event.target.checked,
        value: $event.target.value
      })}}}),_c('label',{attrs:{"for":label}},[_vm._v(_vm._s(label))])])}))}
var staticRenderFns = []

export { render, staticRenderFns }